// const quoteForm = document.getElementById('quote-form');
var recaptchaToken = null;
const advancedForms = document.querySelectorAll('[data-advanced-form]');
const recaptchaLabel = document.querySelector(".recaptcha-label");
const countryFieldsMap = {
  'United States - US': 'state',
  'Canada - CA': 'province',
  'Japan - JP': 'prefecture',
  'United Kingdom - UK': 'county',
};

if (advancedForms) {
  advancedForms.forEach((form) => {
    form.addEventListener('input', handleFormInteraction);
    form.addEventListener('submit', handleFormInteraction);
  });
}

function handleFormInteraction(event) {
  event.preventDefault();
  const currentForm = this;

  if (event.type === 'submit' && validateForm(currentForm)) {
    const submitButton = currentForm.querySelector('[type="submit"]');
    submitButton.innerText = submitButton.getAttribute('data-alt-text');

    ajaxPost(currentForm, () => {
      formSuccess(currentForm);
    });

    event.preventDefault();
  }

  if (event.target.id === 'country') {
    const selectedCountry = event.target.value;
    const countryDependantFields = currentForm.querySelectorAll('[data-dependant-of="country"]');

    countryDependantFields.forEach((field) => {
      const fieldInput = field.querySelector('input, select');

      if (field.id === countryFieldsMap[selectedCountry] + '-field-group') {
        field.classList.remove('is-hidden');
        fieldInput.disabled = false;
      } else {
        field.classList.add('is-hidden');
        fieldInput.disabled = true;
      }
    });
  }

  if (event.target.id === 'lead-source') {
    const selectedLeadSource = event.target.value;
    const leadOtherAdditionalInfo = currentForm.querySelector('[data-condition="Event/Other"]');
    const additionalInfoField = leadOtherAdditionalInfo.querySelector('input');

    if (selectedLeadSource === 'Event/Other') {
      leadOtherAdditionalInfo.classList.remove('is-hidden');
      additionalInfoField.disabled = false;
    } else {
      leadOtherAdditionalInfo.classList.add('is-hidden');
      additionalInfoField.disabled = true;
    }
  }
}

function validateForm(form) {
  let formIsValid = true;

  const formInputs = form.querySelectorAll('input, email, textarea, select');
  const formErrorMessage = form.querySelector('[data-form-error-message]');
  const invalidInputs = [];

  formInputs.forEach((input) => {
    const fieldGroup = input.closest('.field-group');

    if (input.required && !input.disabled) {
      let inputIsValid = true;

      // Look for empty text-based inputs
      if ((input.type === 'text' || input.type === 'email' || input.type === 'textarea') && input.value.length === 0) {
        inputIsValid = false;
      }

      // Check for malformed email address
      if (input.type === 'email' && !emailformIsValid(input.value)) {
        inputIsValid = false;
      }

      if (input.type === 'select-one' && input.value=='none') {
        inputIsValid = false;
      }

      // Handle invalid inputs
      if (inputIsValid) {
        fieldGroup.classList.remove('invalid-input');
      } else {
        invalidInputs.push(input);
        fieldGroup.classList.add('invalid-input');
        formIsValid = false;
      }
    }
  });
   
  // Check for recaptcha token
  if (recaptchaToken === null) {
    formIsValid = false;
    recaptchaLabel.style="color:#c8102e; font-weight:bold;";
    //recaptchaLabel.scrollIntoView({ block: 'end' });
  } else {
    recaptchaLabel.style="";
  }

  // Check if form is valid
  if (formIsValid) {
    formErrorMessage.classList.add('is-hidden');
  } else {
    formErrorMessage.classList.remove('is-hidden');
    formErrorMessage.scrollIntoView({ block: 'end' });
  }

  return formIsValid;
}

function formSuccess(form) {
  if (!form) {
    form = document.querySelector('form');
  }
  const formSuccessMessage = document.getElementById('form-success');

  if (form.id === 'quote-form') {
    formSuccessMessage.innerHTML = `Thanks for getting in touch! Our friendly team will contact you shortly.<br/>Please check your spam folder if you don't hear from us 🤞`;
  }

  formSuccessMessage.classList.remove('is-hidden');
  form.classList.add('is-hidden');
}

/**
 * Takes a form node and sends it over AJAX.
 * @param {HTMLFormElement} form - Form node to send
 * @param {function} callback - Function to handle onload.
 */
function ajaxPost(form, callback) {
  if (!form) return;

  const formData = new FormData(form);

  if (form.id === 'quote-form') {
    const interestedProducts = [];
    const communicationPreferences = [];

    [
      'product-hc1',
      'product-hc1-studio',
      'product-hc1-venture',
      'product-traveler',
      'product-adaptiv-for-vans',
    ].forEach(option => {
      if (formData.get(option)) { interestedProducts.push(option) }
    });

    [
      'communication-preference-email',
      'communication-preference-phone',
      'communication-preference-text',
    ].forEach(option => {
      if (formData.get(option)) { communicationPreferences.push(formData.get(option)) }
    });

    const form = new FormData();
    form.append("contact_request[first_name]", formData.get('first-name'));
    form.append("contact_request[last_name]", formData.get('last-name'));
    form.append("contact_request[email]", formData.get('email-address'));
    form.append("contact_request[phone_number]", formData.get('phone'));
    form.append("contact_request[country]", formData.get('country'));
    form.append("contact_request[region]", formData.get('state'));
    form.append("contact_request[zip]", formData.get('postal-zip'));
    form.append("contact_request[source]", "Contact Form");
    form.append("contact_request[interested_products]", interestedProducts.join(','));
    form.append("contact_request[communication_preferences]", communicationPreferences.join(','));
    form.append("contact_request[found_source]", formData.get('lead-source') === 'Event/Other' ? formData.get('lead-source-other') : formData.get('lead-source'));
    form.append("contact_request[message]", formData.get('message'));

    const  requestToProxyServerSettings = {
      "url": "https://happiercamper-mailer-proxy.herokuapp.com/contact_requests",
      "method": "POST",
      "timeout": 0,
      "processData": false,
      "mimeType": "multipart/form-data",
      "contentType": false,
      "data": form,
    };

    $.ajax(requestToProxyServerSettings).done(function (response) {
      // we will handle to klaviyo for now
      const settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "g": "XHE6bS", // Klaviyo Contact List
          "$fields": "$first_name,$last_name,$phone_number,$country,$region,$zip,$source,Interested Product,Communication Preferrence,Found Source,Message",
          "email": formData.get('email-address'),
          "$first_name": formData.get('first-name'),
          "$last_name": formData.get('last-name'),
          "$phone_number": formData.get('phone'),
          "$country": formData.get('country'),
          "$region": formData.get('state'),
          "$zip": formData.get('postal-zip'),
          "Interested Product": interestedProducts.join(','),
          "Communication Preferrence": communicationPreferences.join(','),
          "Found Source": formData.get('lead-source') === 'Event/Other' ? formData.get('lead-source-other') : formData.get('lead-source'),
          "Message": formData.get('message'),
          "$source": "Contact Form",
        }
      }

      $.ajax(settings).done(response => {
        if (response.success) {
          callback();
        }
      });
    });
  } else {
    const url = form.action;
    const xhr = new XMLHttpRequest();

    // var params = serialize(form);
    

    // Display the key/value pairs
    // for (let pair of formData.entries()) {
    //   console.log(pair[0]+ ', '+ pair[1]);
    // }

    xhr.open('POST', url);

    //All preperations are clear, send the request!
    xhr.send(formData);

    // Handle Results
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) { // Success
          if (callback) {
            callback();
          }
        } else { // Failure
        }
      }
    }
  }
}

function emailformIsValid (email) {
  return /\S+@\S+\.\S+/.test(email)
}

function recaptchaCallback(token){
  console.log("got recaptcha")
  recaptchaToken = token;
}